import { Link, useLocation } from 'react-router-dom'
import { FlexBox, TransitionElement, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { Club } from '@fable/types'
import { clubChatRoute, clubRoute } from 'app/clubs/routes'
import EyeIconCrossedOut from 'assets/icons/components/EyeIconCrossedOut'
import ClubThumbnail from 'components/club_thumbnail/ClubThumbnail'
import { useFeatureFlags } from 'hooks'

const ClubsList = ({ clubs }: { clubs?: Club[] }) => {
  const location = useLocation()
  const { motion, colors } = useTheme()
  const flagEnabled = useFeatureFlags((s) => s.flagEnabled)
  const chatFF = flagEnabled('chat')

  return (
    <ul
      className={css`
        margin: 0 auto;
        width: 100%;
        ${motion.transition()};
      `}
    >
      {clubs?.map((club: Club, i: number) => (
        <li
          key={i}
          className={css`
            + li {
              margin-top: 23px;
            }
            ${motion.transition()};
            &:hover {
              ${motion.moveY(-15)}
            }
          `}
        >
          <TransitionElement index={i} transitionType="staggerUp">
            <Link
              to={{
                search: clubRoute({ club }).search,
                pathname:
                  chatFF && location.pathname.includes('your-clubs')
                    ? clubChatRoute(club)
                    : clubRoute({ club }).pathname,
              }}
            >
              <FlexBox
                className={css`
                  background: ${colors.whiteFang};
                  padding: 12px;
                  min-height: 100px;
                  border-radius: 8px;
                `}
              >
                <ClubThumbnail
                  clubData={club}
                  className={css`
                    flex: 1 0 auto;
                    max-width: 60px;
                    margin: 16px 8px 0px 0px;
                  `}
                />
                <FlexBox
                  justifyContent="space-between"
                  flexDirection="column"
                  className={css`
                    align-self: stretch;
                    flex: 1 1 auto;
                  `}
                >
                  <div>
                    <Text type="body" sizing="L" text={club.title} />
                    <Text
                      type="body"
                      sizing="S"
                      text={club.current_book?.title as string}
                    />
                  </div>
                  <Text
                    type="body"
                    sizing="S"
                    color={colors.hurricane}
                    text={`${club.member_count} Readers • Public`}
                  />
                </FlexBox>
                {club.access_type !== 'open' && (
                  <div>
                    <EyeIconCrossedOut />
                  </div>
                )}
              </FlexBox>
            </Link>
          </TransitionElement>
        </li>
      ))}
    </ul>
  )
}
export default ClubsList
